"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const PeopleStore_1 = require("../../model/PeopleStore");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const hui_1 = require("@mit/hui");
const VaccineAdministered_1 = require("./VaccineAdministered");
const EligibleUpload_1 = __importDefault(require("./EligibleUpload"));
const VaccineUpload_1 = __importDefault(require("./VaccineUpload"));
const react_2 = require("react");
const VaccinationReviews_1 = __importDefault(require("./VaccinationReviews"));
const VaccineHold_1 = __importDefault(require("../vaccineHold/VaccineHold"));
const VaccineRequests_1 = __importDefault(require("../vaccineRequests/VaccineRequests"));
const VaccineComponent = ({ covidNav, roles }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(false);
    const [fullyVaccinated, setFullyVaccinated] = (0, react_1.useState)(false);
    const [tabs, setTabs] = (0, react_1.useState)("vaccinations");
    const [showEligibleUpload, setShowEligibleUpload] = (0, react_1.useState)(false);
    const [showVaccineUpload, setShowVaccineUpload] = (0, react_1.useState)(false);
    const handleEligibleShowUpload = () => {
        setShowEligibleUpload(true);
    };
    const handleEligibleCloseUpload = () => {
        setShowEligibleUpload(false);
    };
    const handleVaccineShowUpload = () => {
        setShowVaccineUpload(true);
    };
    const handleVaccineCloseUpload = () => {
        setShowVaccineUpload(false);
    };
    (0, react_1.useEffect)(() => {
        setLoading(false);
        if ((PeopleStore_1.peopleStore === null || PeopleStore_1.peopleStore === void 0 ? void 0 : PeopleStore_1.peopleStore.vaccineList) === undefined && !isLoading) {
            fetchVaccineResults();
        }
    }, []);
    const fetchVaccineResults = () => {
        setLoading(true);
        // let searchDate = new Date();
        // let dateString = `${searchDate.getFullYear()}-${searchDate.getMonth() + 1 < 10 ? "0" + (searchDate.getMonth() + 1) : searchDate.getMonth() + 1}-${
        // 	searchDate.getDate() < 10 ? "0" + searchDate.getDate() : searchDate.getDate()
        // }`;
        let dateString = '';
        setLoading(true);
        covidNav.currentDateString = dateString;
        MedicalApi_1.default.fetchVaccineResults().then((vaccineDetailResponse) => {
            if (vaccineDetailResponse.error) {
                setLoading(false);
                setError(true);
                //todo: handle error
            }
            else if (vaccineDetailResponse.unauth) {
                setUnAuth(true);
            }
            else {
                if (vaccineDetailResponse.items) {
                    setLoading(false);
                    PeopleStore_1.peopleStore.setVaccineList(vaccineDetailResponse.items);
                }
            }
        });
    };
    const reloadDataCompleted = (date, only_complete) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (!date) {
            date = covidNav.currentDateString;
        }
        else {
            covidNav.currentDateString = date;
        }
        const vaccineDetailResponse = yield MedicalApi_1.default.fetchVaccineResults(date, only_complete);
        if (vaccineDetailResponse.error) {
            setLoading(false);
            //todo: handle error
        }
        else if (vaccineDetailResponse.unauth) {
            setUnAuth(true);
        }
        else {
            if (vaccineDetailResponse.items) {
                setLoading(false);
                PeopleStore_1.peopleStore.setVaccineList(vaccineDetailResponse.items);
            }
        }
    });
    const getInitialCalendarValue = () => {
        if (covidNav.currentDateString)
            return covidNav.currentDateString;
        // let searchDate = new Date();
        // let dateString = `${searchDate.getFullYear()}-${searchDate.getMonth() + 1 < 10 ? "0" + (searchDate.getMonth() + 1) : searchDate.getMonth() + 1}-${
        // 	searchDate.getDate() < 10 ? "0" + searchDate.getDate() : searchDate.getDate()
        // }`;
        return null;
    };
    const navItems = [
        {
            icon: "",
            iconOnly: false,
            text: "Vaccinations",
            state: tabs === "vaccinations" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => { setTabs("vaccinations"); },
        },
        {
            icon: "",
            iconOnly: false,
            text: "Review Vaccine Uploads",
            state: tabs === "vaccinationreview" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => { setTabs("vaccinationreview"); },
        },
        {
            icon: "",
            iconOnly: false,
            text: "Holds",
            state: tabs === "vaccinehold" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => setTabs("vaccinehold"),
        },
        {
            icon: "",
            iconOnly: false,
            text: "Requests",
            state: tabs === "requests" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => setTabs("requests"),
        }
    ];
    //if (error) return <Error context={ErrorContext.Component} message="Failed to fecth Vaccine results" type={ErrorType.Generic} />;
    if (unAuth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "contacttracingtable" }, { children: (0, jsx_runtime_1.jsx)(hui_1.NavBar, { tabs: navItems, type: hui_1.NavBarTypes.Text, itemAlignment: hui_1.ItemAlignment.Left }) })), tabs === "vaccinations" && ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "calendar-picker" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-xl-4" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-12 text-left" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "toggle-vacc" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Toggle, { choice: "Negative", onStateChanged: (e) => {
                                                            e.choice === "Positive" ? setFullyVaccinated(true) : setFullyVaccinated(false);
                                                            covidNav.currentDateString = '';
                                                            reloadDataCompleted("", e.choice === "Positive" ? true : false);
                                                        } }) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "toggle-vacc2" }, { children: "Show fully vaccinated people." }))] })) })) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-xl-4" }, { children: covidNav.globalTableIsLoading
                                        ? (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'inline-block', width: '40%' } }, { children: (0, jsx_runtime_1.jsx)(hui_1.Textbox, { name: "CalendarInput", isLoading: true }) }))
                                        : !fullyVaccinated && (0, jsx_runtime_1.jsx)(hui_1.CalendarInput, { onChange: (e) => reloadDataCompleted(e), value: getInitialCalendarValue(), id: "vaccineDateSelector" }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-xl-4" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "controls" }, { children: [(roles === null || roles === void 0 ? void 0 : roles.roles.includes("medical")) && ((0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Secondary | hui_1.ButtonType.Ghost, text: "Import Elected Individuals", onClick: () => handleEligibleShowUpload() })), (roles === null || roles === void 0 ? void 0 : roles.roles.includes("medical")) && (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary, text: "Import Results", onClick: () => handleVaccineShowUpload() })] })) }))] })) })), (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ peopleStore: PeopleStore_1.peopleStore }, { children: (0, jsx_runtime_1.jsx)(VaccineAdministered_1.VaccineAdministered, { isLoading: isLoading }) })), (0, jsx_runtime_1.jsx)(EligibleUpload_1.default, { show: showEligibleUpload, onClose: handleEligibleCloseUpload }), (0, jsx_runtime_1.jsx)(VaccineUpload_1.default, { show: showVaccineUpload, onClose: handleVaccineCloseUpload })] })), tabs === "vaccinationreview" && (0, jsx_runtime_1.jsx)(VaccinationReviews_1.default, {}), tabs === "vaccinehold" && (0, jsx_runtime_1.jsx)(VaccineHold_1.default, {}), tabs === "requests" && (0, jsx_runtime_1.jsx)(VaccineRequests_1.default, {})] }));
};
const Vaccine = (0, mobx_react_1.inject)("covidNav", "roles", "peopleStore")((0, mobx_react_1.observer)(VaccineComponent));
exports.default = Vaccine;
